'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _sharedJacketCover = require('@bibliocommons/shared-jacket-cover');

var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);

var _bibItemInfo = require('../../bib-item-info');

var _bibItemInfo2 = _interopRequireDefault(_bibItemInfo);

require('../styles/SearchResultItem.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchResultItem = function (_BcReactComponent) {
  _inherits(SearchResultItem, _BcReactComponent);

  function SearchResultItem(props) {
    _classCallCheck(this, SearchResultItem);

    var _this = _possibleConstructorReturn(this, (SearchResultItem.__proto__ || Object.getPrototypeOf(SearchResultItem)).call(this, props));

    _this.bindAll('focusOnTitle');
    return _this;
  }

  _createClass(SearchResultItem, [{
    key: 'focusOnTitle',
    value: function focusOnTitle() {
      if (this._bibItemInfo) {
        this._bibItemInfo.focusOnTitle();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          item = _props.item,
          children = _props.children;

      return _react2.default.createElement(
        'div',
        { className: 'cp-user-list-search-result-item' },
        _react2.default.createElement(
          'div',
          { className: 'search-result-contents' },
          _react2.default.createElement(
            'div',
            { className: 'item-inner-content' },
            _react2.default.createElement(
              'div',
              { className: 'jacket-wrapper' },
              _react2.default.createElement(_sharedJacketCover2.default, {
                alt: '',
                format: item.getIn(['bibListItem', 'format']),
                src: SearchResultItem.getJacketCoverSrc(item),
                size: 'small' })
            ),
            _react2.default.createElement(_bibItemInfo2.default, {
              showAvailability: true,
              item: item,
              ref: function ref(el) {
                return _this2._bibItemInfo = el;
              },
              availabilityDetailActions: this.props.availabilityDetailActions,
              compact: true })
          ),
          _react2.default.createElement(
            'div',
            null,
            children
          )
        )
      );
    }
  }], [{
    key: 'getJacketCoverSrc',
    value: function getJacketCoverSrc(item) {
      var jacket = item.get('jacketCover');
      return _immutable2.default.Map({
        small: jacket.get('smallCover'),
        medium: jacket.get('mediumCover'),
        large: jacket.get('largeCover'),
        local_url: jacket.get('localUrl'),
        type: jacket.get('type')
      });
    }
  }]);

  return SearchResultItem;
}(_baseBcReactComponent2.default);

SearchResultItem.propTypes = {
  listItems: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape).isRequired,
  item: _bcPropTypes.listItemShape.isRequired,
  children: _react.PropTypes.element,
  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired
};

exports.default = SearchResultItem;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/search-result-item/components/SearchResultItem.component.js
// module id = 1336
// module chunks = 0